import React, { useState, useRef } from 'react'
import { useSelector } from 'react-redux'

import ReactToPrint from 'react-to-print'
import { PrintContent } from '../tools'

import {
  Grid, Dialog, Checkbox, FormControlLabel,
  DialogTitle as MuiDialogTitle, Typography, Button,
  IconButton, DialogContent as MuiDialogContent
} from '@material-ui/core'

import { Close as CloseIcon } from '@material-ui/icons'

import { makeStyles, withStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  contentList: {
    width: '100%'
  },
  accordionDetails: {
    backgroundColor: '#f5f5f5',
    borderRadius: '1em',
    margin: theme.spacing(0, 2, 2, 2)
  },
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    },
    width: '100%'
  },
  greenText: {
    color: '#97b557'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  divider: {
    backgroundColor: 'black',
    height: '1px',
    border: 'none'
  },
  printPaper: {
    padding: '1rem',
    marginTop: '2.5rem'
  }
}))

const StyledCheckBox = withStyles({
  root: {
    color: '#A4D164',
    '&$checked': {
      color: '#A4D164'
    }
  },
  checked: {}
})((props) => <Checkbox color='default' {...props} />)

const PrintCapturesPreview = ({ captures, toggleModal, open }) => {
  const componentRef = useRef()

  const classes = useStyles()
  const { imagePath: OrgAvatar = '', imageKey: ImageKey = '' } = useSelector(state => state.orgSettings.general)

  // Determine whether the supervisor has permissions to view quarantined capture images; if so, then include the real image in the print result.
  const userPermissions = useSelector(state => state.auth.permissions)
  const quarantineViewPermission = userPermissions && userPermissions.length ? userPermissions.includes('violation-quarantine-viewer') : false

  const [showComments, setShowComments] = useState(false)
  const [showHistory, setShowHistory] = useState(false)

  const toggleComments = () => {
    setShowComments(!showComments)
  }

  const toggleHistory = () => {
    setShowHistory(!showHistory)
  }

  const printModalToggle = () => {
    toggleModal()
    setShowComments(false)
    setShowHistory(false)
  }

  const renderUnit = (capture) => {
    const arr = capture.units.map((unit) => unit.unitName)
    return arr.join('/')
  }
  return (
    <>
      <Dialog open={open} onClose={printModalToggle} className='filterModal' fullWidth maxWidth='md'>
        <MuiDialogTitle disableTypography>
          <Typography variant='h4' color='primary' classes={{ colorPrimary: classes.greenText }} className='font-weight-bold'>Print Capture</Typography>
          <IconButton aria-label='close' className={classes.closeButton} onClick={printModalToggle}>
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          <Grid container direction='row' justify='center'>
            <ReactToPrint
              trigger={() => <Button className={classes.blueBtn}>Click Here to Print</Button>}
              content={() => componentRef.current}
            />
          </Grid>
          <Grid container justify='center' direction='row' className='mt-3'>
            <Grid item xs={6} container justify='center' direction='column'>
              <Grid item container justify='center' direction='row'>
                <FormControlLabel
                  value={showComments}
                  control={
                    <StyledCheckBox
                      checked={showComments}
                      onChange={() => toggleComments(!showComments)}
                    />
                  }
                  label={<span className='font-weight-bold'>Include Comments</span>}
                  labelPlacement='start'
                  className='m-0 font-weight-bold'
                />
              </Grid>
            </Grid>
            <Grid item xs={6} container justify='center' direction='column'>
              <Grid item container justify='center' direction='row'>
                <FormControlLabel
                  value={showHistory}
                  control={
                    <StyledCheckBox
                      checked={showHistory}
                      onChange={() => toggleHistory(!showHistory)}
                    />
                  }
                  label={<span className='font-weight-bold' style={{ marginLeft: '.5rem' }}>Include History</span>}
                  labelPlacement='start'
                  className='m-0 font-weight-bold'
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item container direction='column' ref={componentRef}>
            <PrintContent
              captures={captures}
              classes={classes}
              showComments={showComments}
              showHistory={showHistory}
              renderUnit={renderUnit}
              orgAvatar={OrgAvatar}
              orgImageKey={ImageKey}
              ref={componentRef}
              quarantineViewPermission={quarantineViewPermission}
            />
          </Grid>
        </MuiDialogContent>
      </Dialog>
    </>
  )
}

export default PrintCapturesPreview
